// Auth helper utilities — extracted from App.jsx for shared use
// Patent claims exercised: P-001 18-24

/**
 * Get or create a stable device ID for multi-device session management.
 * Persists in localStorage across sessions — only cleared on explicit reset.
 */
export function getOrCreateDeviceId() {
  let id = localStorage.getItem('healist_device_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('healist_device_id', id);
  }
  return id;
}

/**
 * #83 correlation spine (FE side) — a per-browser-session id sent as X-Session-Id so backend log
 * lines (and, in Phase C, beta telemetry) can be joined to one session. sessionStorage-scoped:
 * a new tab/session gets a fresh id; cleared when the tab closes.
 */
export function getOrCreateSessionId() {
  let id = sessionStorage.getItem('healist_session_id');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('healist_session_id', id);
  }
  return id;
}

/**
 * Parse user-agent string to generate a human-readable device name.
 * Used for session display in Active Sessions card.
 */
export function getDeviceNameFromUA() {
  const ua = navigator.userAgent || '';
  let browser = 'Browser';
  if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome') && ua.includes('Safari')) browser = 'Chrome';
  else if (ua.includes('Firefox')) browser = 'Firefox';
  else if (ua.includes('Safari')) browser = 'Safari';

  let os = '';
  if (ua.includes('Macintosh') || ua.includes('Mac OS')) os = 'Mac';
  else if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('iPhone')) os = 'iPhone';
  else if (ua.includes('iPad')) os = 'iPad';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('Linux')) os = 'Linux';

  return os ? `${browser} on ${os}` : browser;
}
